import React, { useState, useEffect, useRef } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Select from "react-select";
import { api_path } from "../../shared.js";
import swal from "sweetalert";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

export function ShipmentProcessFormContent(props) {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_EMAIL);
  const [getEmpID, setEmpID] = useState(props.EMP_CODE);
  const [isSubmitting, setSubmitting] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [searchParams] = useSearchParams();
  const [subjectName, setSubjectName] = useState("");
  const id = searchParams.get("param");
  const copy = searchParams.get("copy");
  const [GET_BOUND_TYPE, SET_BOUND_TYPE] = useState("");
  const [GET_SHIPMENT_TERM, SET_SHIPMENT_TERM] = useState("");
  const [GET_SHIPPER_CODE, SET_SHIPPER_CODE] = useState("");
  const [GET_SHIPPER_NAME, SET_SHIPPER_NAME] = useState("");
  const [GET_CNEE_CODE, SET_CNEE_CODE] = useState("");
  const [GET_CNEE_NAME, SET_CNEE_NAME] = useState("");
  const [GET_AGENT_CODE, SET_AGENT_CODE] = useState("");
  const [GET_AGENT_NAME, SET_AGENT_NAME] = useState("");
  const [GET_SHIPPERLOAD_CODE, SET_SHIPPERLOAD_CODE] = useState("");
  const [GET_SHIPPERLOAD_NAME, SET_SHIPPERLOAD_NAME] = useState("");
  const [GET_COLOAD_CODE, SET_COLOAD_CODE] = useState("");
  const [GET_COLOAD_NAME, SET_COLOAD_NAME] = useState("");
  const [GET_PARTY_3RD, SET_PARTY_3RD] = useState("");
  const [GET_PARTY_3RD_NAME, SET_PARTY_3RD_NAME] = useState("");
  const [GET_CREDIT_TERM, SET_CREDIT_TERM] = useState("");
  const [GET_POR, SET_POR] = useState("");
  const [GET_POL, SET_POL] = useState("");
  const [GET_POD, SET_POD] = useState("");
  const [GET_DEL, SET_DEL] = useState("");
  const [GET_FINAL, SET_FINAL] = useState("");
  const [GET_CTNR_SIZE, SET_CTNR_SIZE] = useState("");
  const [GET_CTNR_TYPE, SET_CTNR_TYPE] = useState("");
  const [GET_GW, SET_GW] = useState("");
  const [GET_DOOR_BY, SET_DOOR_BY] = useState("");
  const [GET_INCOTERM, SET_INCOTERM] = useState("");
  const [GET_HSCODE, SET_HSCODE] = useState("");
  const [GET_COMMODITY, SET_COMMODITY] = useState("");
  const [GET_LOAD_TYPE, SET_LOAD_TYPE] = useState("");
  const [GET_CHARGE_TERM, SET_CHARGE_TERM] = useState("");
  const [GET_MBL_TYPE, SET_MBL_TYPE] = useState("");
  const [GET_HBL_TYPE, SET_HBL_TYPE] = useState("");
  const [GET_SHIPPING_CODE, SET_SHIPPING_CODE] = useState("");
  const [GET_SHIPPING, SET_SHIPPING] = useState("");
  const [GET_TRUCKING_CODE, SET_TRUCKING_CODE] = useState("");
  const [GET_TRUCKING, SET_TRUCKING] = useState("");
  const [GET_INSURANCE, SET_INSURANCE] = useState("");
  const [GET_AGENT_SALES_EMAIL, SET_AGENT_SALES_EMAIL] = useState("");
  const [GET_ISF_BY, SET_ISF_BY] = useState("");
  const [GET_AMS_SCAC, SET_AMS_SCAC] = useState("");
  const [GET_ACI_SCAC, SET_ACI_SCAC] = useState("");
  const [GET_FILING_BY, SET_FILING_BY] = useState("");
  const [GET_PREALERT_EMAIL, SET_PREALERT_EMAIL] = useState("");
  const [GET_BOOKING_PIC, SET_BOOKING_PIC] = useState("");
  const [GET_DOC_PIC, SET_DOC_PIC] = useState("");
  const [GET_REMARK_TO_CS, SET_REMARK_TO_CS] = useState("");
  const [GET_REMARK_TO_DOC, SET_REMARK_TO_DOC] = useState("");
  const [GET_REMARK_TO_ACC, SET_REMARK_TO_ACC] = useState("");
  useEffect(() => {
    if (id > 0) {
      fetch(api_path + "/MS_SHIPMENT_PROCESS.php?SHIPMENT_ID=" + id)
        .then((res) => res.json())
        .then((res) => {
          const array = res;
          for (const i of array) {
            if (copy == 1) {
              setSubjectName("Copy SOP");
            }else{
            setSubjectName("Edit SOP");
            }
            SET_BOUND_TYPE(i.BOUND_TYPE);
            SET_SHIPMENT_TERM(i.SHIPMENT_TERM);
            SET_SHIPPER_NAME(i.SHIPPER_NAME)
            SET_CNEE_NAME(i.CNEE_NAME)
            SET_AGENT_NAME(i.AGENT_NAME)
            SET_SHIPPERLOAD_NAME(i.SHIPPERLOAD_NAME)
            SET_COLOAD_NAME(i.COLOAD_NAME)
            SET_PARTY_3RD_NAME(i.PARTY_3RD_NAME)
            SET_CREDIT_TERM(i.CREDIT_TERM)
            SET_POR(i.POR)
            SET_POL(i.POL)
            SET_POD(i.POD)
            SET_DEL(i.DEL)
            SET_FINAL(i.FINAL)
            SET_CTNR_SIZE(i.CTNR_SIZE)
            SET_CTNR_TYPE(i.CTNR_TYPE)
            SET_GW(i.GW)
            SET_DOOR_BY(i.DOOR_BY)
            SET_INCOTERM(i.INCOTERM)
            SET_HSCODE(i.HSCODE)
            SET_COMMODITY(i.COMMODITY)
            SET_LOAD_TYPE(i.LOAD_TYPE)
            SET_CHARGE_TERM(i.CHARGE_TERM)
            SET_MBL_TYPE(i.MBL_TYPE)
            SET_HBL_TYPE(i.HBL_TYPE)
            SET_SHIPPING_CODE(i.SHIPPING_CODE)
            SET_SHIPPING(i.SHIPPING)
            SET_TRUCKING_CODE(i.TRUCKING_CODE)
            SET_TRUCKING(i.TRUCKING)
            SET_INSURANCE(i.INSURANCE)
            SET_AGENT_SALES_EMAIL(i.AGENT_SALES_EMAIL)
            SET_ISF_BY(i.ISF_BY)
            SET_AMS_SCAC(i.AMS_SCAC)
            SET_ACI_SCAC(i.ACI_SCAC)
            SET_FILING_BY(i.FILING_BY)
            SET_PREALERT_EMAIL(i.PREALERT_EMAIL)
            SET_BOOKING_PIC(i.BOOKING_PIC)
            SET_DOC_PIC(i.DOC_PIC)
            SET_REMARK_TO_CS(i.REMARK_TO_CS)
            SET_REMARK_TO_DOC(i.REMARK_TO_DOC)
            SET_REMARK_TO_ACC(i.REMARK_TO_ACC)
          }
        });
    }else{
        setSubjectName("Add");
    }
}, [id]);
const handleSubmit = (event) => {
    event.preventDefault();
   
  };
  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
    }
  }
  return (
    <Container maxWidth="lg" className="BorderBox">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <label className="head">{subjectName}</label>
      </Grid>
      <form
        onSubmit={handleSubmit}
        onKeyDown={(e) => {
          handleKeyDown(e, handleSubmit);
        }}
      >
        <Grid mb={2} container spacing={2}>
          <Grid item xs={12} sm={4}>
          <label>EXPORT/IMPORT</label>
            <TextField
              size="small"
              name="GET_BOUND_TYPE"
              variant="outlined"
              fullWidth
              id="GET_BOUND_TYPE"
              value={GET_BOUND_TYPE}
              onChange={(e) => SET_BOUND_TYPE(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>&nbsp;</Grid>
          <Grid item xs={12} sm={4}>&nbsp;</Grid>
          <Grid item xs={12} sm={4}>
          <label>SHIPPER</label>
            <TextField
              size="small"
              name="GET_SHIPPER_NAME"
              variant="outlined"
              fullWidth
              id="GET_SHIPPER_NAME"
              value={GET_SHIPPER_NAME}
              onChange={(e) => SET_SHIPPER_NAME(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>CNEE</label>
            <TextField
              size="small"
              name="GET_CNEE_NAME"
              variant="outlined"
              fullWidth
              id="GET_CNEE_NAME"
              value={GET_CNEE_NAME}
              onChange={(e) => SET_CNEE_NAME(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>AGENT</label>
            <TextField
              size="small"
              name="GET_AGENT_NAME"
              variant="outlined"
              fullWidth
              id="GET_AGENT_NAME"
              value={GET_AGENT_NAME}
              onChange={(e) => SET_AGENT_NAME(e.target.value)}
            />
          </Grid>
          
    
          <Grid item xs={12} sm={4}>
          <label>CO LOAD</label>
            <TextField
              size="small"
              name="GET_COLOAD_NAME"
              variant="outlined"
              fullWidth
              id="GET_COLOAD_NAME"
              value={GET_COLOAD_NAME}
              onChange={(e) => SET_COLOAD_NAME(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>3rd partry shipment</label>
            <TextField
              size="small"
              name="GET_PARTY_3RD_NAME"
              variant="outlined"
              fullWidth
              id="GET_PARTY_3RD_NAME"
              value={GET_PARTY_3RD_NAME}
              onChange={(e) => SET_PARTY_3RD_NAME(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>&nbsp;</Grid>
          <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
          <Grid item xs={12} sm={4}>
          <label>POL</label>
            <TextField
              size="small"
              name="GET_POL"
              variant="outlined"
              fullWidth
              id="GET_POL"
              value={GET_POL}
              onChange={(e) => SET_POL(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>LOAD_TYPE</label>
            <TextField
              size="small"
              name="GET_LOAD_TYPE"
              variant="outlined"
              fullWidth
              id="GET_LOAD_TYPE"
              value={GET_LOAD_TYPE}
              onChange={(e) => SET_LOAD_TYPE(e.target.value)}
            />
          </Grid>
     
          <Grid item xs={12} sm={4}>&nbsp;</Grid>
          <Grid item xs={12} sm={4}>
          <label>POD</label>
            <TextField
              size="small"
              name="GET_POD"
              variant="outlined"
              fullWidth
              id="GET_POD"
              value={GET_POD}
              onChange={(e) => SET_POD(e.target.value)}
            />
          </Grid>
          {/* <Grid item xs={12} sm={3}>
          <label>POR</label>
            <TextField
              size="small"
              name="GET_POR"
              variant="outlined"
              fullWidth
              id="GET_POR"
              value={GET_POR}
              onChange={(e) => SET_POR(e.target.value)}
            />
          </Grid> */}
       <Grid item xs={12} sm={4}>
          <label>DEL</label>
            <TextField
              size="small"
              name="GET_DEL"
              variant="outlined"
              fullWidth
              id="GET_DEL"
              value={GET_DEL}
              onChange={(e) => SET_DEL(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>FINAL</label>
            <TextField
              size="small"
              name="GET_FINAL"
              variant="outlined"
              fullWidth
              id="GET_FINAL"
              value={GET_FINAL}
              onChange={(e) => SET_FINAL(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
          {/* <Grid item xs={12} sm={3}>
          <label>TYPE</label>
            <TextField
              size="small"
              name="GET_CTNR_TYPE"
              variant="outlined"
              fullWidth
              id="GET_CTNR_TYPE"
              value={GET_CTNR_TYPE}
              onChange={(e) => SET_CTNR_TYPE(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
          <label>SIZE</label>
            <TextField
              size="small"
              name="GET_CTNR_SIZE"
              variant="outlined"
              fullWidth
              id="GET_CTNR_SIZE"
              value={GET_CTNR_SIZE}
              onChange={(e) => SET_CTNR_SIZE(e.target.value)}
            />
          </Grid> */}
          <Grid item xs={12} sm={4}>
          <label>INCOTERM</label>
            <TextField
              size="small"
              name="GET_INCOTERM"
              variant="outlined"
              fullWidth
              id="GET_INCOTERM"
              value={GET_INCOTERM}
              onChange={(e) => SET_INCOTERM(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>DOOR BY</label>
            <TextField
              size="small"
              name="GET_DOOR_BY"
              variant="outlined"
              fullWidth
              id="GET_DOOR_BY"
              value={GET_DOOR_BY}
              onChange={(e) => SET_DOOR_BY(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>&nbsp;</Grid>
          <Grid item xs={12} sm={4}>
          <label>HS Code</label>
            <TextField
              size="small"
              name="GET_HSCODE"
              variant="outlined"
              fullWidth
              id="GET_HSCODE"
              value={GET_HSCODE}
              onChange={(e) => SET_HSCODE(e.target.value)}
            />
       
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>COMMODITY</label>
            <TextField
              size="small"
              name="GET_COMMODITY"
              variant="outlined"
              fullWidth
              id="GET_COMMODITY"
              value={GET_COMMODITY}
              onChange={(e) => SET_COMMODITY(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>&nbsp;</Grid>
          <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
          {/* <Grid item xs={12} sm={3}>
          <label>GW</label>
            <TextField
              size="small"
              name="GET_GW"
              variant="outlined"
              fullWidth
              id="GET_GW"
              value={GET_GW}
              onChange={(e) => SET_GW(e.target.value)}
            />
          </Grid> */}
          <Grid item xs={12} sm={4}>
          <label>Direct/HBL</label>
            <TextField
              size="small"
              name="GET_HBL_TYPE"
              variant="outlined"
              fullWidth
              id="GET_HBL_TYPE"
              value={GET_HBL_TYPE}
              onChange={(e) => SET_HBL_TYPE(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>&nbsp;</Grid>
          <Grid item xs={12} sm={4}>&nbsp;</Grid>
          <Grid item xs={12} sm={4}>
          <label>CHARGE_TERM</label>
            <TextField
              size="small"
              name="GET_CHARGE_TERM"
              variant="outlined"
              fullWidth
              id="GET_CHARGE_TERM"
              value={GET_CHARGE_TERM}
              onChange={(e) => SET_CHARGE_TERM(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>MBL_TYPE</label>
            <TextField
              size="small"
              name="GET_MBL_TYPE"
              variant="outlined"
              fullWidth
              id="GET_MBL_TYPE"
              value={GET_MBL_TYPE}
              onChange={(e) => SET_MBL_TYPE(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>&nbsp;</Grid>
           <Grid item xs={12} sm={4}>
          <label>SHIPMENT TERM</label>
            <TextField
              size="small"
              name="GET_SHIPMENT_TERM"
              variant="outlined"
              fullWidth
              id="GET_SHIPMENT_TERM"
              value={GET_SHIPMENT_TERM}
              onChange={(e) => SET_SHIPMENT_TERM(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>HBL_TYPE</label>
            <TextField
              size="small"
              name="GET_HBL_TYPE"
              variant="outlined"
              fullWidth
              id="GET_HBL_TYPE"
              value={GET_HBL_TYPE}
              onChange={(e) => SET_HBL_TYPE(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>&nbsp;</Grid>
          <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
          <Grid item xs={12} sm={4}>
          <label>SHIPPING</label>
            <TextField
              size="small"
              name="GET_SHIPPING"
              variant="outlined"
              fullWidth
              id="GET_SHIPPING"
              value={GET_SHIPPING}
              onChange={(e) => SET_SHIPPING(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>TRUCKING</label>
            <TextField
              size="small"
              name="GET_TRUCKING"
              variant="outlined"
              fullWidth
              id="GET_TRUCKING"
              value={GET_TRUCKING}
              onChange={(e) => SET_TRUCKING(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>INSURANCE</label>
            <TextField
              size="small"
              name="GET_INSURANCE"
              variant="outlined"
              fullWidth
              id="GET_INSURANCE"
              value={GET_INSURANCE}
              onChange={(e) => SET_INSURANCE(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
          <Grid item xs={12} sm={4}>
          <label>AMS_SCAC</label>
            <TextField
              size="small"
              name="GET_AMS_SCAC"
              variant="outlined"
              fullWidth
              id="GET_AMS_SCAC"
              value={GET_AMS_SCAC}
              onChange={(e) => SET_AMS_SCAC(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>ACI_SCAC</label>
            <TextField
              size="small"
              name="GET_ACI_SCAC"
              variant="outlined"
              fullWidth
              id="GET_ACI_SCAC"
              value={GET_ACI_SCAC}
              onChange={(e) => SET_ACI_SCAC(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>FILING_BY</label>
            <TextField
              size="small"
              name="GET_FILING_BY"
              variant="outlined"
              fullWidth
              id="GET_FILING_BY"
              value={GET_FILING_BY}
              onChange={(e) => SET_FILING_BY(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>ISF_BY</label>
            <TextField
              size="small"
              name="GET_ISF_BY"
              variant="outlined"
              fullWidth
              id="GET_ISF_BY"
              value={GET_ISF_BY}
              onChange={(e) => SET_ISF_BY(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>&nbsp;</Grid>
          <Grid item xs={12} sm={4}>&nbsp;</Grid>
          <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
          <Grid item xs={12} sm={4}>
          <label>PRE ALERT EMAIL</label>
            <TextField
              size="small"
              name="GET_PREALERT_EMAIL"
              variant="outlined"
              fullWidth
              id="GET_PREALERT_EMAIL"
              value={GET_PREALERT_EMAIL}
              onChange={(e) => SET_PREALERT_EMAIL(e.target.value)}
              multiline
              rows={4}
            />
          </Grid>
          <Grid item xs={12} sm={4}>&nbsp;</Grid>
          <Grid item xs={12} sm={4}>&nbsp;</Grid>
          <Grid item xs={12} sm={4}>
          <label>AGENT SALES EMAIL</label>
            <TextField
              size="small"
              name="GET_AGENT_SALES_EMAIL"
              variant="outlined"
              fullWidth
              id="GET_AGENT_SALES_EMAIL"
              value={GET_AGENT_SALES_EMAIL}
              onChange={(e) => SET_AGENT_SALES_EMAIL(e.target.value)}
              multiline
              rows={4}
            />
          </Grid>
          
          
         
          
          
          <Grid item xs={12} sm={4}>
          <label>BOOKING PIC</label>
            <TextField
              size="small"
              name="GET_BOOKING_PIC"
              variant="outlined"
              fullWidth
              id="GET_BOOKING_PIC"
              value={GET_BOOKING_PIC}
              onChange={(e) => SET_BOOKING_PIC(e.target.value)}
              multiline
              rows={4}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>DOC PIC</label>
            <TextField
              size="small"
              name="GET_DOC_PIC"
              variant="outlined"
              fullWidth
              id="GET_DOC_PIC"
              value={GET_DOC_PIC}
              onChange={(e) => SET_DOC_PIC(e.target.value)}
              multiline
              rows={4}
            />
          </Grid>
          <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
          <Grid item xs={12} sm={4}>
          <label>REMARK TO CS</label>
            <TextField
              size="small"
              name="GET_DOC_PIC"
              variant="outlined"
              fullWidth
              id="GET_REMARK_TO_CS"
              value={GET_REMARK_TO_CS}
              onChange={(e) => SET_REMARK_TO_CS(e.target.value)}
              multiline
              rows={4}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>REMARK TO DOC</label>
            <TextField
              size="small"
              name="GET_REMARK_TO_DOC"
              variant="outlined"
              fullWidth
              id="GET_REMARK_TO_DOC"
              value={GET_REMARK_TO_DOC}
              onChange={(e) => SET_REMARK_TO_DOC(e.target.value)}
              multiline
              rows={4}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <label>REMARK TO ACC</label>
            <TextField
              size="small"
              name="GET_REMARK_TO_ACC"
              variant="outlined"
              fullWidth
              id="GET_REMARK_TO_ACC"
              value={GET_REMARK_TO_ACC}
              onChange={(e) => SET_REMARK_TO_ACC(e.target.value)}
              multiline
              rows={4}
            />
          </Grid>
          <Grid container className="Box" spacing={2}>
            <Grid item xs={12} sm={6}>
              <Button
                isLoading={isSubmitting}
                disabled={!isButtonDisabled}
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
              >
                Save
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                type="button"
                fullWidth
                variant="outlined"
                color="primary"
                onClick={goBack}
              >
                &larr; Go Back
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
